<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FRC20 代币</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">使用Web3和 NodeJS与 Contract 交互</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">Dynamic Fee Transactions</a></p>
            <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Atomic Transaction Fees</a></p>
    
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">FRC20 代币</div>
      <div class="p3">FRC20 令牌必须在 IFRC20.sol 中实现接口 IFRC20。这是一个模板合约 FRC20Token.template。用户只需要根据自己的要求填写_name、_symbol、_decimals和_totalSupply即可：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">constructor() public {</div>
          <div style="padding:5px 0">_name = {{TOKEN_NAME}};</div>
          <div style="padding:5px 0">_symbol = {{TOKEN_SYMBOL}};</div>
          <div style="padding:5px 0">_decimals = {{DECIMALS}};</div>
          <div style="padding:5px 0">_totalSupply = {{TOTAL_SUPPLY}};</div>
          <div style="padding:5px 0">_balances[msg.sender] = _totalSupply;</div>
          <div style="padding:5px 0">emit Transfer(address(0), msg.sender, _totalSupply);</div>
          <div style="padding:5px 0">}</div>
        </div>
      </div>
      <div class="p3">然后用户可以使用Remix IDE和 Metamask 编译并部署 FRC20 合约到 FaxChain。</div>

      <div id="box2" class="p2">使用Web3和 NodeJS与 Contract 交互</div>
      <div class="p3">连接到 FaxChain 的公共 RPC 端点</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">const Web3 = require('web3');</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// testnet</div>
          <div style="padding:5px 0">const web3 = new Web3('http://13.230.73.12:26659');</div>
        </div>
      </div>
      <div class="p3">创建钱包</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">web3.eth.accounts.create([entropy]);</div>
        </div>
      </div>
      <div class="p3">输出：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">web3.eth.accounts.create();</div>
          <div style="padding:5px 0">{</div>
          <div style="padding:5px 0">address: '0x03975c070801D6110EBD8301a0F159f89FB7a4C0',</div>
          <div style="padding:5px 0">privateKey: 'BB1C835AB9770454318D8F19079AA1498EFE3B57654E8084134ADB7854969D93',</div>
          <div style="padding:5px 0">signTransaction: [Function: signTransaction],</div>
          <div style="padding:5px 0">sign: [Function: sign],</div>
          <div style="padding:5px 0">encrypt: [Function: encrypt]</div>
          <div style="padding:5px 0">}</div>
        </div>
      </div>
      <div class="p3">找回钱包</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">const account = web3.eth.accounts.privateKeyToAccount("BB1C835AB9770454318D8F19079AA1498EFE3B57654E8084134ADB7854969D93")</div>
        </div>
      </div>
      <div class="p3">查看余额</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">web3.eth.getBalance(holder).then(console.log);</div>
        </div>
      </div>
      <div class="p3">输出：FAX 的余额将增加 e18</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">6249621999900000000</div>
        </div>
      </div>

      <div class="p3">创建交易参数</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>Object - 要发送的交易对象：</li>
          <li>from - String|Number：发送账户的地址。如果未指定，则使用 web3.eth.defaultAccount 属性。或者 web3.eth.accounts.wallet 中本地钱包的地址或索引。</li>
          <li>to - 字符串：（可选）消息的目标地址，对于合约创建交易未定义。</li>
          <li>value - Number|String|BN|BigNumber：（可选）在 wei 中为交易转移的价值，如果是合约创建交易，也是捐赠。</li>
          <li>gas - Number：（可选，默认值：待定）交易使用的gas量（未使用的gas被退还）。</li>
          <li>gasPrice - Number|String|BN|BigNumber：（可选）此交易的 gas 价格（以 wei 为单位），默认为 web3.eth.gasPrice。</li>
          <li>数据 - 字符串：（可选）包含合约函数调用数据的 ABI 字节字符串，或者在合约创建交易的情况下为初始化代码。</li>
          <li>nonce - Number：（可选）nonce 的整数。这允许覆盖您自己的使用相同 nonce 的待处理事务。</li>
        </ul>
      </div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// // Make a transaction using the promise</div>
          <div style="padding:5px 0">web3.eth.sendTransaction({</div>
          <div style="padding:5px 0">from: holder,</div>
          <div style="padding:5px 0">to: '0x0B75fbeB0BC7CC0e9F9880f78a245046eCBDBB0D',</div>
          <div style="padding:5px 0">value: '1000000000000000000',</div>
          <div style="padding:5px 0">gas: 4500000,</div>
          <div style="padding:5px 0">gasPrice: 17e8,</div>
          <div style="padding:5px 0">}, function(err, transactionHash) {</div>
          <div style="padding:5px 0">if (err) {</div>
          <div style="padding:5px 0">console.log(err);</div>
          <div style="padding:5px 0">} else {</div>
          <div style="padding:5px 0">console.log(transactionHash);</div>
          <div style="padding:5px 0">}</div>
          <div style="padding:5px 0">});</div>
        </div>
      </div>

      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">FRC20 代币</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">使用Web3和 NodeJS与 Contract 交互</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(3)" class="s2"><a :class="{active:flag==3}" href="#box3">Dynamic Fee Transactions</a></p>
        <p @click="activeted(4)" class="s2"><a :class="{active:flag==4}" href="#box4">Atomic Transaction Fees</a></p>

      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaxchainTransactionFee',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>